import { createFileRoute, useParams } from "@tanstack/react-router";
import { z } from "zod";
import { AccountDetailPage } from "@/components/crm/AccountDetailPage";

export const Route = createFileRoute("/user/_layout/crm/accounts_/$id")({
  validateSearch: z.object({ tab: z.string().min(1).catch("general").default("general") }),
  component: UserAccountDetail,
});

function UserAccountDetail() {
  const { id } = useParams({ from: "/user/_layout/crm/accounts_/$id" });
  const { tab } = Route.useSearch();
  return <AccountDetailPage accountId={id} role="user" activeTab={tab} />;
}
